import * as gzSystemDown from './system-down.provider';

export default angular.module('gazelle.core.systemDown', [
  'pascalprecht.translate'
])
  .provider(gzSystemDown.name, gzSystemDown.default)
  .config(gzSystemDownConfig)
  .name;

function gzSystemDownConfig($httpProvider) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  $httpProvider.interceptors.push(gzSystemDown.name);
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/system-down/system-down.module.js